<form class="profile-dialog" (ngSubmit)="save()">
  <ngf-dialog-title class="profile-dialog__title" mat-dialog-title>{{ copy.title }}</ngf-dialog-title>

  <mat-dialog-content class="profile-dialog__body">
    @if (data.mode === 'avatar') {
      <fieldset class="profile-dialog__radios">
        <legend class="profile-dialog__label">Avatar Source</legend>
        <label class="profile-dialog__radio">
          <input type="radio" name="avatarSource" value="file" [(ngModel)]="source" cdkFocusInitial />
          File Upload
        </label>
        <label class="profile-dialog__radio">
          <input type="radio" name="avatarSource" value="gravatar" [(ngModel)]="source" />
          Gravatar
        </label>
      </fieldset>
    }

    @if (usesGravatar) {
      <label class="profile-dialog__label" for="profileGravatar">Gravatar Email</label>
      <input class="profile-dialog__input" id="profileGravatar" name="gravatar" type="email" [(ngModel)]="gravatar" />
    } @else {
      <p class="profile-dialog__text" [id]="hintId">{{ copy.hint }}</p>

      <span class="profile-dialog__label" id="profileImageLabel">Image</span>
      <!-- A styled file picker; the native input stays in the tab order but is visually hidden. -->
      <div class="profile-dialog__picker">
        <input #fileInput class="profile-dialog__file sr-only" id="profileImage" type="file" [accept]="accept"
          aria-labelledby="profileImageLabel profileImageName" [attr.aria-describedby]="hintId" (change)="pick($event)"
          [attr.cdkFocusInitial]="data.mode === 'banner' ? '' : null" />
        <label class="ut-btn ut-btn--secondary ut-btn--sm" for="profileImage">
          <span class="material-icons" aria-hidden="true">file_upload</span>
          Choose image
        </label>
        <span class="profile-dialog__file-name" id="profileImageName">{{ file?.name || 'No file chosen' }}</span>
        @if (file) {
          <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="clearFile(fileInput)">Remove</button>
        }
      </div>
      @if (fileError === 'type') {
        <p class="profile-dialog__error" role="status" aria-live="polite">
          Your image file <strong>{{ file!.name }}</strong> is an unsupported file type.
          Please upload a .jpg, .jpeg, .png, or .gif instead.
        </p>
      } @else if (fileError === 'size') {
        <p class="profile-dialog__error" role="status" aria-live="polite">
          Your image file <strong>{{ file!.name }}</strong> exceeds the maximum allowed size of {{ maxSizeLabel }}.
          Please upload a smaller file, or compress this one and try again.
        </p>
      }
    }
    <p class="profile-dialog__terms">
      All file uploads must adhere to our <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">uTest Terms of Use</a>.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="profile-dialog__actions">
    <button type="button" class="ut-btn ut-btn--secondary" mat-dialog-close>Cancel</button>
    <button type="submit" class="ut-btn" [disabled]="!canSave || saving()">{{ copy.title }}</button>
  </mat-dialog-actions>
</form>
